import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import BarChartTemplate from "views/molecules/charts/template/BarChartTemplate"
import { useAppContext } from "components/AppContext"
import { useEntity } from "hooks/useAxios"
import useRequest from "hooks/useRequest"
import ScoreEntity from "services/entities/ScoreEntity"
import Loading from "components/widgets/Loading"

const ChartODD13GHGEmissionsBreakdownPurchasesByCategoryMolecule = () => {
  const { t } = useTranslation()
  const { currentNode, currentPeriod } = useAppContext()
  const scoreEntity = useEntity(ScoreEntity)
  const { data, isLoading, reload } = useRequest(
    () => scoreEntity.getOdd13GhgEmissionsBreakdownByCategory(),
    [currentNode, currentPeriod],
    {
      condition: !!currentNode && currentNode?.has_purchases,
      cacheKey: `odd13-category-${currentNode?.id}-${currentPeriod?.id}`,
    }
  )

  if (isLoading) {
    return <Loading />
  }

  if (!data) return null

  const translationPrefix = `score:score.13.purchaseChartGHGBreakdownByCategory`

  return (
    <BarChartTemplate
      title={t(`${translationPrefix}.title`)}
      data={data.data}
      labelPath={`${translationPrefix}.labels`}
      labelKeys={data.label_key}
      unitPath={"units:units.emission"}
      unitKey={data.unit_key}
      helpText={t(`${translationPrefix}.help`)}
    />
  )
}

export default ChartODD13GHGEmissionsBreakdownPurchasesByCategoryMolecule
